import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IEmploymentState } from './employment.state';

export class EmploymentSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly employmentState = (state: IRootState): IEmploymentState => {
    return state.employment as IEmploymentState;
  };

  static readonly model = createSelector(EmploymentSelectors.employmentState, (employment: IEmploymentState) => {
    return employment.model;
  });

  static readonly data = createSelector(EmploymentSelectors.employmentState, (employment: IEmploymentState) => {
    return employment.data;
  });
}
